import{ api_base_url } from "../../../constants";
import { getAppLocale } from "../../../utils/app-locale";
import { API_INSTANCE } from "../../../utils/service-http";
import { appConfiguration } from "../../../utils/app-starter";

export const validateDuplicateIsland = (config) => {
  const mainOverrideString = appConfiguration.main ? `&main=${appConfiguration.main}` : '';
  return API_INSTANCE.post(`${api_base_url}/configurations/${config}/validate-duplicate-island?locale=${getAppLocale()}${mainOverrideString}`, {})
    .then((success) => {
      return success.data.payload;
    }).catch((error) => {
      console.log("Error", error);
      throw error;
    });
}
